"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Featuredservices() {
  const {
    ref: introRef,
    isVisible: introVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: cardsRef,
    isVisible: cardsVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const languages = [{
    id: 1,
    flag: "HK",
    flagLabel: "Corporate",
    greeting: "Social & Networking.",
    language: "Corporate Travel",
    tagline: "Seamless logistics for high-performing teams in the heart of Asia.",
    learners: "12",
    image: "https://offsiteasia.com/wp-content/uploads/2026/06/PHOTO-2026-05-24-08-01-53-scaled.jpg?v=zx6486pcf6d",
    srcset: "https://offsiteasia.com/wp-content/uploads/2026/06/PHOTO-2026-05-24-08-01-53-scaled.jpg?v=zle9x4rq7ue-wvc-srcset",
    sizes: "https://offsiteasia.com/wp-content/uploads/2026/06/PHOTO-2026-05-24-08-01-53-scaled.jpg?v=y84x9lolnw-wvc-sizes",
    alt: "Professional corporate team meeting in a modern Hong Kong boardroom",
    flagLabelClassName: "!bg-[url(https://offsiteasia.com/wp-content/uploads/2026/06/PHOTO-2026-05-24-08-01-53-scaled.jpg)]"
  }, {
    id: 2,
    flag: "HK",
    flagLabel: "Immersion",
    greeting: "Culture.",
    language: "Immersive Workshops",
    tagline: "Deep dive into the unique heritage and traditions of Hong Kong.",
    learners: "8",
    image: "https://offsiteasia.com/wp-content/uploads/2026/06/Dragon-Boat-02.jpg?v=frmbbh0n0jh",
    srcset: "https://offsiteasia.com/wp-content/uploads/2026/06/Dragon-Boat-02.jpg?v=legeyvrls6p",
    sizes: "https://offsiteasia.com/wp-content/uploads/2026/06/Dragon-Boat-02.jpg?v=3e7cfwdvq2p",
    alt: "Traditional Hong Kong cultural workshop setting"
  }, {
    id: 3,
    flag: "HK",
    flagLabel: "Active",
    greeting: "Sightseeing.",
    language: "Orientation tours",
    tagline: "Bond through guided city exploration, hikes and coastal experiences.",
    learners: "15",
    image: "https://offsiteasia.com/wp-content/uploads/2026/05/hong-kong-city-at-night-2026-03-24-23-10-46-utc-scaled.jpg?v=wlvupzqzoq",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638249/img/hong_kong_after_dark.png",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1638249/img/hong_kong_after_dark.png",
    alt: "Team bonding activity on a scenic Hong Kong hiking trail"
  }];
  return <section data-section-id="640" id="featuredservices" className="text-foreground py-24 md:py-32 lg:py-[140px] bg-muted light">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        {}
        <div ref={introRef} className={`grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-16 transition-all duration-700 ease-out ${introVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="lg:col-span-7 max-w-[720px]">
            <span className="font-mono text-xs font-medium uppercase tracking-[0.2em] text-primary">
              Our Expertise
            </span>
            <h2 className="font-default mt-5 text-4xl font-light leading-[1.1] text-foreground md:text-5xl lg:text-6xl">Curated&nbsp; experiences. <em className="italic font-normal text-primary" data-ast-id="f:/src/pages/Home/sections/Featuredservices.tsx|sig:vusxbs" data-ast-start="3242" data-ast-end="3316">Unforgettable moments</em> for your team.</h2>
          </div>
          <div className="lg:col-span-5 lg:pt-4">
            <p className="font-default text-base leading-relaxed text-muted-foreground md:text-lg">We curate bespoke programs that blend professional logistics with the vibrant cultural spirit of Hong Kong.</p>
          </div>
        </div>

        {}
        <div ref={cardsRef} className="mt-16 grid grid-cols-1 gap-8 md:gap-6 lg:grid-cols-3 lg:gap-8 md:mt-20">
          {languages.map((lang, i) => <Link key={lang.id} to="/ServicesPage" data-index={i} className={`group relative flex flex-col overflow-hidden rounded-lg bg-card shadow-md transition-all duration-500 ease-out hover:-translate-y-1.5 hover:shadow-lg md:h-[480px] ${cardsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
          transitionDelay: cardsVisible ? `${i * 120}ms` : "0ms"
        }}>
              {}
              <div className="relative h-64 overflow-hidden md:h-[60%]">
                <img src={lang.image} data-wvc-srcset={lang.srcset} data-wvc-sizes={lang.sizes} alt={lang.alt} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]" />
              </div>

              {}
              <div className="relative flex flex-1 flex-col justify-between bg-card p-7 md:p-8">
                <div>
                  {}
                  <span className="inline-flex items-center gap-2 rounded-md bg-accent px-3 py-1 font-mono text-[10px] font-semibold uppercase tracking-wider text-accent-foreground">
                    <span className="inline-block h-1.5 w-1.5 rounded-lg bg-primary" />
                    {lang.flagLabel}
                  </span>

                  {}
                  <h3 className="font-default mt-5 text-3xl font-normal italic text-foreground md:text-[2rem]">
                    {lang.greeting}
                  </h3>
                  <p className="font-default mt-1 text-xl font-medium text-foreground md:text-2xl not-italic">
                    {lang.language}
                  </p>

                  {}
                  <p className="font-default mt-3 text-sm leading-relaxed text-muted-foreground">
                    {lang.tagline}
                  </p>
                </div>

                {}
                <div className="mt-6 flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <span className="relative flex h-2 w-2">
                      <span className="absolute inline-flex h-full w-full animate-ping rounded-lg bg-primary opacity-75" />
                      <span className="relative inline-flex h-2 w-2 rounded-lg bg-primary" />
                    </span>
                    <span className="font-mono text-xs text-muted-foreground">
                      {lang.learners} active programs
                    </span>
                  </div>

                  <span className="font-default inline-flex items-center gap-1.5 text-sm font-medium text-foreground">
                    <span className="relative">
                      View Details
                      <span className="absolute -bottom-0.5 left-0 h-px w-0 bg-primary transition-all duration-500 ease-out group-hover:w-full" />
                    </span>
                    <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                  </span>
                </div>

                {}
                <span className="pointer-events-none absolute bottom-0 left-0 h-[2px] w-0 bg-primary transition-all duration-500 ease-out group-hover:w-full" />
              </div>
            </Link>)}
        </div>
      </div>
    </section>;
}